export default __webpack_public_path__ + "media/src/assets/images/Union-becade12c976459e044534b96504c663.svg";